import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    AfterViewInit
} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {BsModalEventsEmitter} from 'src/app/modules/shared/events/bsModal.events';
import {LocalisationService} from 'src/app/modules/shared/services/localisation.service';
import {ShoppingListComponent} from './shopping-list.component';
import * as moment from 'moment';
import {DiaryService} from '../../../../shared/services/diary.service';

@Component({
    selector: 'app-send-to-friend',
    templateUrl: './send-to-friend.component.html',
    styleUrls: ['./send-to-friend.component.scss'],
})
export class SendToFriendComponent implements OnInit, AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;

    shoppingListComponent: ShoppingListComponent;
    email = '';

    isSuccess: boolean = null;

    constructor(
        public readonly bsModalRef: BsModalRef,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        private readonly diaryService: DiaryService,
    ) {
    }

    ngOnInit() {
    }

    getFromDate() {
        if (!this.shoppingListComponent) {
            return '';
        }

        return moment(this.shoppingListComponent.fromDate).format('DD.MM.YYYY');
    }

    getToDate() {
        if (!this.shoppingListComponent) {
            return '';
        }

        return moment(this.shoppingListComponent.toDate).format('DD.MM.YYYY');
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    save() {
        if (this.email.length > 3 && this.isEmailValid(this.email)) {
            this.diaryService.sendShoppingListAccess(
                this.email,
                moment(this.shoppingListComponent.fromDate).format('YYYY-MM-DD'),
                moment(this.shoppingListComponent.toDate).format('YYYY-MM-DD')
            ).subscribe(() => {
                this.isSuccess = true;
            }, () => {
                this.isSuccess = false;
            });
        }
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    private isEmailValid(email): boolean {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    isIOS() {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    }
}
